import React, { Component } from 'react';
import { Modal, Icon, Divider } from 'antd';
import Img from 'react-image';

export default class AfspUserSettingsControls extends Component {
    constructor(props) { super(props); }
    render() {
        const
        s = this.props.styles,
        { handleModalView } = this.props,
        { usePathname, user } = this.props.images,
        { showSettings } = this.props.modals,
        { USER_DETAILS, ROLES } = window.session.jwtSession,
        hasProviderAdmin = ROLES.find(e => e === 'PROVIDER_ADMIN');
        return (
            <div>
                <Modal
                    title={(
                        <div style={{
                            textAlign: 'center',
                            fontSize: '20px'
                        }}>
                            <div style={{ display: 'inline-block', marginRight: '10px' }}>
                                <Icon type='setting' />
                            </div>
                            <div style={{ display: 'inline-block' }}>
                                {'Settings'}
                            </div>
                        </div>
                    )}
                    onCancel={() => handleModalView('settings')}
                    footer={null}
                    wrapClassName="vertical-center-modal"
                    visible={showSettings}
                    style={{
                        position: 'absolute',
                        top: '20%',
                        right: '10%',
                        bottom: '20%',
                        left: '10%'
                    }}
                    bodyStyle={{ padding: '10px' }}
                >
                    <div style={{ textAlign: 'center' }}>
                        <div>
                            <Img
                                src={(usePathname ? `${window.location.pathname}${user}` : `${user}`)}
                                style={{ width: '80px', height: '80px' }}
                            />
                        </div>
                        <div>
                            <span style={{ fontSize: '18px', fontWeight: 'bold', fontStyle: 'italic' }}>{
                                `${USER_DETAILS.FIRST_NAME} ` +
                                `${USER_DETAILS.LAST_NAME}`
                            }</span>
                        </div>
                        {!hasProviderAdmin ? null : (
                            <div>
                                <span style={{ fontSize: '18px' }}>
                                    {'Provider Admin'}
                                </span>
                            </div>
                        )}
                    </div>
                    <Divider
                        type='horizontal'
                        style={{ margin: '10px 0px 10px 0px' }}
                    />
                    <div>
                        {'Settings options here...'}
                    </div>
                </Modal>
            </div>
        );
    }
}
